export const SET_USER_ROLES = `SET_USER_ROLES`;

export const FETCH_USER_POSITIONS = 'FETCH_USER_POSITIONS';
export const FETCH_USER_POSITIONS_SUCCESS = 'FETCH_USER_POSITIONS_SUCCESS';
export const FETCH_USER_POSITIONS_FAILED = 'FETCH_USER_POSITIONS_FAILED';

export const setUserRoles = (payload: string[]) => ({
  type: SET_USER_ROLES,
  payload,
});

export const fetchUserPositions = (payload: any) => ({
  type: FETCH_USER_POSITIONS,
  payload,
});

export const fetchUserPositionsSuccess = (payload) => ({
  type: FETCH_USER_POSITIONS_SUCCESS,
  payload,
});

export const fetchUserPositionsFailed = (error) => ({
  type: FETCH_USER_POSITIONS_FAILED,
  error,
});
